import React from "react";
import { ParagraphUtilityVariable } from "@/model";

import { ParagraphInputsProps } from "../model";
import { VariableInputGroup } from "../input";


const ParagraphUtilityVariableCardInputs: React.FC<ParagraphInputsProps<ParagraphUtilityVariable>> = (props) => {
    const { paragraph, onChange } = props;

    return (<>
        <VariableInputGroup required
                            data={paragraph.data}
                            onChange={data => onChange({
                                ...paragraph,
                                data: data
                            })}
        />
    </>);
};

export default ParagraphUtilityVariableCardInputs;
